export function captureModeForDay(logs = []) {
  return logs.some(log => (log.wear_label || 'sotd') === 'sotd') ? 'another' : 'sotd'
}

// A saved SOTD without display metadata has no hero; retain its ledger fallback.
export function homeHistoryLogs(logs, ownerId, heroLog, heroFragrance) {
  return logs.filter(row => row.user_id === ownerId && !(heroLog && heroFragrance && row.id === heroLog.id))
}
